import { cn } from '@/shared/utils/cn';

export interface BrandMarkProps {
  size?: number;
  className?: string;
}

/** Marca: tablero de pizarra con una «P» de tiza y una hoja de maíz (misma geometría que public/favicon.svg). */
export function BrandMark({ size = 32, className }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0', className)}
    >
      <rect
        width="64"
        height="64"
        rx="14"
        className="fill-board stroke-board-fg"
        strokeOpacity=".16"
        strokeWidth="1.5"
      />
      <rect
        x="5"
        y="5"
        width="54"
        height="54"
        rx="10"
        fill="none"
        className="stroke-board-fg"
        strokeOpacity=".3"
        strokeWidth="1.5"
        strokeDasharray="2 3"
      />
      <path
        d="M20 45V21h9.5a7.5 7.5 0 0 1 0 15H20"
        fill="none"
        className="stroke-board-fg"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 45c0-8.5 4.2-13.6 11.5-14.6-1 8.6-5.2 13.7-11.5 14.6z"
        className="fill-board-accent"
      />
    </svg>
  );
}
